// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"505":"523e51","591":"4ae364","930":"ff50b4"}[chunkId] + ".js";
};